import { findAttribute } from '@edicom/common/element/findAttribute';
import { findParent } from '@edicom/common/element/findParent';
import { onDelegation } from '@edicom/common/event/onDelegation';
import { getAttributes } from '@edicom/common/element/getAttributes';

/*
  functión que acepta un HTMLElement para dar acceso su API
*/

export default function element(elem) {
  if (!(elem instanceof HTMLElement)) {
    throw new Error('ecElementService necesita un objeto HTMLElement');
  }
  return {
    eventDelegation: (attr, actions, options) => onDelegation(attr, actions, options),
    findAttribute: attr => findAttribute(elem, attr),
    findParent: (callback, max) => findParent(elem, callback, max),
    getAttributes: () => getAttributes(elem),
  };
}
